import { quillClassFromInstance } from '@calendly/rich-text-editor'

export const insertHtmlAtCursor = (quillEditor, htmlContent, source = 'user') => {
  if (!quillEditor || !htmlContent) {
    return false
  }

  try {
    const Quill = quillClassFromInstance(quillEditor)
    const Delta = Quill.import('delta')

    let selection = quillEditor.getSelection(true)

    if (!selection || selection.index === 0) {
      const editorLength = quillEditor.getLength()
      const defaultIndex = editorLength > 0 ? editorLength - 1 : 0
      selection = { index: defaultIndex, length: 0 }
    }

    const cursorPosition = selection.index
    const htmlDelta = quillEditor.clipboard.convert(htmlContent)

    const insertDelta = new Delta()
      .retain(cursorPosition)
      .concat(htmlDelta)

    quillEditor.updateContents(insertDelta, source)
    quillEditor.setSelection(cursorPosition + htmlDelta.length(), source)
    return true
  } catch (error) {
    return false
  }
}

export const getQuillEditor = (editorRef) => editorRef?.current?.getEditor && editorRef.current.getEditor()
